import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { VerificationSessionGet, getTopupResult } from "../../services/Services";
import { useToasts } from "react-toast-notifications";
// import VerificationResultModal from "./VerificationResultModal";
import { LoadingOverlay } from "../../layout";
import Img from "../../components/Img";
import VerificationResultModal from "../auth/registration/VerificationResultModal";
import ResultModal from "./ResultModal";

 

const CardTopupResult = () => {
  const navigate = useNavigate();
  const { addToast } = useToasts();
  const [mode, setMode] = useState("");
  const [loading, setLoading] = useState(true);
  const id = useLocation().pathname.split("/").pop()
  const [transactionHistoryId, setTransactionHistoryId] = useState()

  useEffect(() => {
    if (id) {
     
      getTopupResult(id)
        .then((res) => {
          setTransactionHistoryId(res.data.Content.TransactionHistoryId)
          if (res.data.Content.Status === "Succeeded") {
            setMode("success");
            setLoading(false);
          } else {
            setMode("error");
            setLoading(false);
          }
        })
        .catch((err) => {
          setMode("error");
          setLoading(false);
          if (err.response.data.errors) {
            return Object.values(err.response.data.errors).map((item: any) => {
              addToast(<div>{item}</div>, {
                appearance: "error",
                autoDismiss: true,
              });
            });
          } else {
            addToast(<div>{err.response.data.StatusMessage}</div>, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    } else if (!id) {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <LoadingOverlay>
        <Img src="/transfers/inex-logo.png" alt="logo" />
      </LoadingOverlay>
    );
  }

  return (
    <div className="bg-[#FBFBFB] h-[100vh]">
      <ResultModal
        mode={mode}
        isOpen={true}
        transactionHistoryId={transactionHistoryId}
        onClose={() => {
          navigate("/home");
        }}
      />
    </div>
  );
};

export default CardTopupResult;
